

const shoudlBustCacheFor = (url, blacklist, whitelist) => {
  if(blacklist) {
    return !blacklist.includes(url);
  } else if(!blacklist && whitelist) {
    return whitelist.includes(url);
  } else {
    return true;
  }
}

const bust = (httpConfig, blacklist, whitelist) => {
  const {url, lang, method, params} = httpConfig;
  let setLang;
  if(lang === 'Spanish'){
    setLang ='es'
  }else if(lang=== 'Bahasa'){
    setLang ='ba'
  }
  if(method === "get" && shoudlBustCacheFor(url, blacklist, whitelist)) {
    if(!params && url.indexOf("?") === -1) {
      if(setLang !== undefined){
          httpConfig.url = `${url}?lang=${setLang}&cacheBuster=${new Date().getTime()}`;
      }else {
          httpConfig.url = `${url}?cacheBuster=${new Date().getTime()}`;
      }
    }else if(setLang !== undefined) {
        httpConfig.url = `${url}&lang=${setLang}&cacheBuster=${new Date().getTime()}`;
    }
    else{
        httpConfig.url = `${url}&cacheBuster=${new Date().getTime()}`;
    }
  }
}

const taxonomyLang = (httpConfig, blacklist, whitelist) => {
  const {url, lang, method, params} = httpConfig;
  let setLang;
  if(lang === 'Spanish'){
    setLang ='es'
  }else if(lang=== 'Bahasa'){
    setLang ='ba'
  }
  if(method === "get" && shoudlBustCacheFor(url, blacklist, whitelist)) {
    if(!params && url.indexOf("?") === -1) {
      if(setLang !== undefined){
          httpConfig.url = `${url}?lang=${setLang}`;
      }else {
        httpConfig.url = `${url}`;
      }
    }else if(setLang !== undefined) {
      httpConfig.url = `${url}?lang=${setLang}`;
    }
    else{
      httpConfig.url = `${url}`;
    }
  }
}

const CacheBuster = {
  bust,
  taxonomyLang
}

export default CacheBuster;



// WEBPACK FOOTER //
// ./src/utils/CacheBuster.js